import { controllerDefinitionBuilder } from '@app/components/Form/helpers';
import { StringRulesBuilder } from '@utilities/json-driven-validator/pre-built-contrains';

export default controllerDefinitionBuilder()
  .addControllerConfig({
    type: 'text',
    name: 'fiscalId',
    label: '',
    placeholder: 'IdOrPasswordFieldPlaceholder',
    defaultViewMode: 'edit',
    responsive: { xs: 12 },
    validationRules: StringRulesBuilder.new().required('IdOrPasswordFieldIsRequired').get(),
  })
  .addControllerConfig({
    type: 'recaptcha',
    name: 'captchaToken',
    label: '',
    placeholder: '',
    defaultViewMode: 'edit',
    responsive: { xs: 12 },
    validationRules: StringRulesBuilder.new().validCaptcha('RecaptchaFieldIsRequired').get(),
  })
  .get();
